import { EBuilderChatActionTypes, TBuilderChatActions } from '../../actions/builderChat';
import { EConsultantCianChatActionTypes, TConsultantCianChatActions } from '../../actions/consultantCianChat';
import { IConsultantCianChatState } from '../../types/consultantCianChat';

const initialState: IConsultantCianChatState = {
  isLoading: false,
  isOpened: false,
  isAutorisationPopupOpened: false,
  chatId: null,
  isErrorPopupOpened: false,
  isError: false,
  isChatExists: false,
  animationCounter: 0,
  animationDelayMs: 30000,
  animationShownCount: 0,
};

export function consultantCianChatReducer(
  state: IConsultantCianChatState = initialState,
  action: TConsultantCianChatActions | TBuilderChatActions,
): IConsultantCianChatState {
  switch (action.type) {
    case EConsultantCianChatActionTypes.OpenAutorisationMotivationPopup:
      return {
        ...state,
        isAutorisationPopupOpened: true,
      };

    case EConsultantCianChatActionTypes.OpenChat:
      return {
        ...state,
        isOpened: true,
        isLoading: false,
        isAutorisationPopupOpened: false,
        chatId: action.payload,
      };

    case EBuilderChatActionTypes.OpenChat: // Закрываем чат с консультантом, если открывается чат с застройщиком по ЖК.
    case EConsultantCianChatActionTypes.CloseChat: {
      return {
        ...state,
        isOpened: false,
        isAutorisationPopupOpened: false,
      };
    }

    case EConsultantCianChatActionTypes.SetChatLoading:
      return {
        ...state,
        isLoading: true,
      };

    case EConsultantCianChatActionTypes.OpenErrorMessage:
      return {
        ...state,
        isError: true,
        isErrorPopupOpened: true,
        isLoading: false,
      };

    case EConsultantCianChatActionTypes.CloseErrorMessage:
      return {
        ...state,
        isErrorPopupOpened: false,
        isAutorisationPopupOpened: false,
      };

    case EConsultantCianChatActionTypes.SetAnimationCounter:
      return {
        ...state,
        animationCounter: action.payload,
      };

    case EConsultantCianChatActionTypes.SetAnimationDelayMs:
      return {
        ...state,
        animationDelayMs: action.payload,
      };

    case EConsultantCianChatActionTypes.SetAnimationShownCount:
      return {
        ...state,
        animationShownCount: action.payload,
      };

    default:
      return state;
  }
}
